import { render, staticRenderFns } from "./assistance.vue?vue&type=template&id=c3d62130&"
import script from "./assistance.vue?vue&type=script&lang=js&"
export * from "./assistance.vue?vue&type=script&lang=js&"
import style0 from "./assistance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports